<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Terms and Conditions</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Terms and Conditions</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="privacy-area pt-100">
    <div class="container">
   <div class="container">
    <h1>Terms & Conditions</h1>

    <h5>Terms & Conditions</h5>
    <p>Welcome to Magnus Recruitment Solutions. By accessing or using our website 
      (<a href="https://magnusrecruitment.com.au">https://magnusrecruitment.com.au</a>), 
      you agree to be bound by the following Terms & Conditions. If you do not accept these terms, please do not use this website.
    </p>

    <h5>1. Website Use</h5>
    <p>This site is provided for individuals and organizations seeking recruitment and employment services. 
      You may not use the site for any illegal or unauthorized purpose.
    </p>

    <h5>2. Intellectual Property</h5>
    <p>All content on this site—including text, graphics, logos, icons, images, audio clips, and software—is the property of 
      Magnus Recruitment Solutions or its licensors and is protected by Australian and international copyright laws.
    </p>

    <h5>3. Job Applications</h5>
    <p>You are responsible for ensuring that all personal information and documents you submit 
      (e.g., resume, cover letter) are accurate and not misleading. We are not responsible for the outcome of any job application 
      submitted through our website.
    </p>

    <h5>4. Candidate & Employer Conduct</h5>
    <p>Users agree not to impersonate others, post false or misleading information, upload malicious files, 
      or attempt unauthorized access.
    </p>

    <h5>5. Third-Party Links</h5>
    <p>Our website may include links to third-party websites. We are not responsible for the content or accuracy 
      of these external sites.
    </p>

    <h5>6. Limitation of Liability</h5>
    <p>Magnus Recruitment Solutions shall not be liable for any indirect, incidental, special, or consequential damages 
      arising from the use or inability to use this website.
    </p>

    <h5>7. Indemnity</h5>
    <p>You agree to indemnify and hold Magnus Recruitment Solutions harmless from any claims,
     liabilities, damages, and expenses arising out of your use of this website.
    </p>

    <h5>8. Changes to Terms</h5>
    <p>We reserve the right to update or modify these Terms & Conditions at any time without
      prior notice.
    </p>

    <h5>9. Governing Law</h5>
    <p>These terms are governed by the laws of New South Wales, Australia
    </p>

    <h5>10.  Contact Us</h5>
    <p>Email: administrator&#64;magnusrecruitment.com.au
      (<a href="https://magnusrecruitment.com.au">https://magnusrecruitment.com.au</a>),
    </p>

  </div>
    </div>
</section>